import React from "react";
import ManualTestingMain from "../function-components/learningCourses/ManualTestingContent";

function ManualTesting() {
  return (
    <>
      <ManualTestingMain />
    </>
  );
}

export default ManualTesting;
